<template>
  <div class="apply-page">
    <div class="apply-main">
      <!-- 背景图 -->
      <img class="apply-bg" src="../assets/images/about/about-1-company.png" alt="" />
      <div class="apply-content">
        <!-- 面包屑 -->
        <div class="apply-crumb">
          <a href="javascript:;" @click="$router.push('/join')">{{ $t('join.hotJobs') }}</a>
          <span class="crumb-sep">&gt;</span>
          <span>{{ jobTitle }}</span>
        </div>
        <div class="apply-card">
          <div class="apply-card-head">
            <h2 class="apply-section-title">{{ $t('join.contactTitle') }}</h2>
            <button class="apply-submit" :disabled="submitting" @click="submit">{{ $t('join.submit') }}</button>
          </div>
          <div class="apply-fields">
            <div class="apply-field">
              <label><span class="required">*</span>{{ $t('join.nameLabel') }}</label>
              <input v-model.trim="form.name" type="text" :placeholder="$t('join.namePh')" @blur="validateField('name')" />
              <p v-if="errors.name" class="field-error">{{ errors.name }}</p>
            </div>
            <div class="apply-field">
              <label><span class="required">*</span>{{ $t('join.phoneLabel') }}</label>
              <input v-model.trim="form.phone" type="tel" :placeholder="$t('join.phonePh')" @blur="validateField('phone')" />
              <p v-if="errors.phone" class="field-error">{{ errors.phone }}</p>
            </div>
            <div class="apply-field">
              <label><span class="required">*</span>{{ $t('join.emailLabel') }}</label>
              <input v-model.trim="form.email" type="email" :placeholder="$t('join.emailPh')" @blur="validateField('email')" />
              <p v-if="errors.email" class="field-error">{{ errors.email }}</p>
            </div>
          </div>
          <h3 class="apply-upload-title">{{ $t('join.uploadTitle') }}</h3>
          <div
            class="apply-drop"
            :class="{ 'is-active': dragging }"
            @click="pickFile"
            @dragover.prevent="dragging = true"
            @dragleave="dragging = false"
            @drop.prevent="onDrop"
          >
            <img class="apply-drop-icon" :src="uploadIcon" alt="" />
            <p class="apply-drop-text">{{ $t('join.uploadTip') }}</p>
            <p class="apply-drop-limit">{{ $t('join.uploadLimit') }}</p>
            <input ref="fileInput" type="file" accept="application/pdf,.pdf" hidden @change="onFileChange" />
          </div>
          <p v-if="file" class="apply-file-info">📄 {{ file.name }}</p>
          <p v-if="errors.file" class="field-error">{{ errors.file }}</p>
        </div>
      </div>
    </div>
    <Footer />
    <!-- 成功弹窗 -->
    <div v-if="showSuccess" class="success-mask">
      <div class="success-dialog">
        <div class="success-art">
          <img class="success-icon" :src="successIcon" alt="" />
        </div>
        <h3 class="success-title">{{ $t('join.successTitle') }}</h3>
        <p class="success-desc">{{ $t('join.successDesc') }}</p>
        <button class="success-btn" @click="onSuccessOk">{{ $t('join.successOk') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import Footer from '../components/Footer.vue'

export default {
  name: 'JobApplyPage',
  components: { Footer },
  data() {
    return {
      // false 时跳过请求，直接提示成功
      apiReady: true,
      form: { name: '', phone: '', email: '' },
      errors: { name: '', phone: '', email: '', file: '' },
      file: null,
      dragging: false,
      submitting: false,
      showSuccess: false,
      // 文件名含空格，用 require 引入
      successIcon: require('@/assets/images/about/join us.png'),
      uploadIcon: require('@/assets/images/about/pdf upload.png')
    }
  },
  computed: {
    jobId() {
      return this.$route.query.job || 'register'
    },
    jobTitle() {
      return this.$t('join.jobs.' + this.jobId)
    }
  },
  methods: {
    validateField(field) {
      this.errors[field] = ''
      if (field === 'name') {
        if (!this.form.name) this.errors.name = this.$t('join.errName')
      } else if (field === 'phone') {
        if (!this.form.phone) {
          this.errors.phone = this.$t('join.errPhone')
        } else if (!/^[+\d][\d\s-]{5,19}$/.test(this.form.phone)) {
          this.errors.phone = this.$t('join.errPhoneFormat')
        }
      } else if (field === 'email') {
        if (!this.form.email) {
          this.errors.email = this.$t('join.errEmail')
        } else if (!/^[\w.-]+@[\w-]+(\.[\w-]+)+$/.test(this.form.email)) {
          this.errors.email = this.$t('join.errEmailFormat')
        }
      }
      return !this.errors[field]
    },
    validateFile() {
      this.errors.file = ''
      if (!this.file) {
        this.errors.file = this.$t('join.errFile')
        return false
      }
      return true
    },
    validate() {
      const okName = this.validateField('name')
      const okPhone = this.validateField('phone')
      const okEmail = this.validateField('email')
      const okFile = this.validateFile()
      return okName && okPhone && okEmail && okFile
    },
    pickFile() {
      this.$refs.fileInput.click()
    },
    onFileChange(e) {
      this.checkFile(e.target.files[0])
      e.target.value = ''
    },
    onDrop(e) {
      this.dragging = false
      this.checkFile(e.dataTransfer.files[0])
    },
    // 仅 PDF 且 ≤5M
    checkFile(file) {
      this.errors.file = ''
      if (!file) return
      const isPdf = file.type === 'application/pdf' || /\.pdf$/i.test(file.name)
      if (!isPdf) {
        this.file = null
        this.errors.file = this.$t('join.errFileType')
        return
      }
      if (file.size > 5 * 1024 * 1024) {
        this.file = null
        this.errors.file = this.$t('join.errFileSize')
        return
      }
      this.file = file
    },
    submit() {
      if (!this.validate()) return
      if (!this.apiReady) {
        this.showSuccess = true
        return
      }
      const data = new FormData()
      data.append('job', this.jobId)
      // 提交岗位名，用于邮件展示
      data.append('jobTitle', this.jobTitle)
      data.append('name', this.form.name)
      data.append('phone', this.form.phone)
      data.append('email', this.form.email)
      data.append('resume', this.file)
      this.submitting = true
      fetch('/admin/join', { method: 'POST', body: data })
        .then((res) => {
          if (!res.ok) throw new Error()
          this.showSuccess = true
          this.form = { name: '', phone: '', email: '' }
          this.file = null
        })
        .catch(() => {
          this.errors.file = this.$t('join.errServer')
        })
        .finally(() => {
          this.submitting = false
        })
    },
    onSuccessOk() {
      this.showSuccess = false
      this.$router.push('/join')
    }
  }
}
</script>

<style scoped>
/* 页面容器 */
.apply-page {
  padding-top: 80px;
}

/* 页面主体 */
.apply-main {
  position: relative;
  min-height: calc(100vh - 80px);
}

.apply-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
  pointer-events: none;
  z-index: 0;
}

/* 内容区 */
.apply-content {
  position: relative;
  z-index: 1;
  max-width: 1100px;
  margin: 0 auto;
  padding: 74px 40px 140px;
}

.apply-crumb {
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-size: 40px;
  font-weight: 500;
  color: #FFFFFF;
  margin-bottom: 50px;
}

/* 面包屑链接 */
.apply-crumb a {
  color: rgba(255, 255, 255, 0.6);
  text-decoration: none;
  position: relative;
  font-weight: 400;
}

.apply-crumb a::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: -4px;
  width: 75%;
  height: 2px;
  background: #FFFFFF;
}

/* hover 时不增加额外下划线 */
.apply-crumb a:hover {
  text-decoration: none;
}

.crumb-sep {
  margin: 0 12px;
}

/* 表单卡片 */
.apply-card {
  background: rgba(245, 245, 245, 0.5);
  border-radius: 14px;
  padding: 44px 60px 56px;
}

/* 卡片头部 */
.apply-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 30px;
}

/* 卡片内标题 */
.apply-section-title {
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-size: 24px;
  font-weight: 500;
  color: #252525;
  margin: 0;
}

/* 提交按钮 */
.apply-submit {
  background: #00ADBB;
  color: #FFFFFF;
  border: none;
  border-radius: 8px;
  padding: 10px 44px;
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-size: 18px;
  cursor: pointer;
  transition: background 0.3s ease;
}

.apply-submit:hover {
  background: #00C4D4;
}

.apply-submit:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* 三列输入区 */
.apply-fields {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 32px;
}

.apply-field {
  display: flex;
  flex-direction: column;
}

.apply-field label {
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-size: 18px;
  font-weight: 500;
  color: #252525;
  margin-bottom: 10px;
}

.apply-field .required {
  color: #E53935;
  margin-right: 4px;
}

/* 输入框 */
.apply-field input {
  border: none;
  border-bottom: 1px solid #000000;
  border-radius: 0;
  background: transparent;
  outline: none;
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-size: 15px;
  color: #252525;
  padding: 11px 14px;
  transition: border-color 0.3s ease;
}

.apply-field input::placeholder {
  color: #6C6C6C;
}

/* 错误提示 */
.field-error {
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-size: 13px;
  color: #E53935;
  margin: 8px 0 0 0;
}

/* 上传标题 */
.apply-upload-title {
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-size: 18px;
  font-weight: 500;
  color: #252525;
  margin: 40px 0 16px 0;
}

/* 上传区 */
.apply-drop {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 230px;
  background: transparent;
  border: 1px solid #000000;
  border-radius: 10px;
  cursor: pointer;
}

.apply-drop-icon {
  width: 54px;
  height: 54px;
  object-fit: contain;
}

/* 上传提示 */
.apply-drop-text {
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-size: 16px;
  color: #252525;
  margin: 14px 0 6px 0;
}

/* 上传限制说明 */
.apply-drop-limit {
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-size: 14px;
  color: #252525;
  margin: 0;
}

/* 已选文件名 */
.apply-file-info {
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-size: 15px;
  color: #252525;
  margin: 16px 0 0 0;
}

/* 成功弹窗遮罩 */
.success-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.success-dialog {
  width: 560px;
  background: #FFFFFF;
  border-radius: 16px;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.2);
  padding: 48px 60px 44px;
  text-align: center;
}

.success-art {
  margin-bottom: 8px;
}

/* 成功图标 */
.success-icon {
  width: 160px;
  height: auto;
  display: inline-block;
}

/* 弹窗标题 */
.success-title {
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-size: 24px;
  font-weight: 500;
  color: #252525;
  margin: 0 0 16px 0;
}

/* 说明文字 */
.success-desc {
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-size: 15px;
  color: #8C8C8C;
  line-height: 1.8;
  margin: 0 0 30px 0;
}

/* 确认按钮 */
.success-btn {
  background: #00ADBB;
  color: #FFFFFF;
  border: none;
  border-radius: 8px;
  padding: 12px 0;
  width: 240px;
  font-family: 'Noto Sans SC', 'PingFang SC', sans-serif;
  font-size: 17px;
  cursor: pointer;
  transition: background 0.3s ease;
}

.success-btn:hover {
  background: #00C4D4;
}

/* 移动端 */
@media (max-width: 1024px) {
  .apply-page {
    padding-top: 0;
  }

  .apply-main {
    min-height: 100vh;
  }

  .apply-content {
    padding: 14vh 6% 10vh;
  }

  .apply-crumb {
    font-size: 5.6vw;
    margin-bottom: 4vh;
  }

  .crumb-sep {
    margin: 0 2vw;
  }

  .apply-card {
    padding: 4vh 5vw 5vh;
    border-radius: 3vw;
  }

  .apply-card-head {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 3vh;
  }

  .apply-section-title {
    font-size: 5.6vw;
  }

  .apply-submit {
    padding: 1vh 6vw;
    font-size: 4.27vw;
  }

  /* 三列改单列 */
  .apply-fields {
    grid-template-columns: 1fr;
    gap: 3vh;
  }

  .apply-field label {
    font-size: 4vw;
    margin-bottom: 0;
  }

  .apply-field input {
    font-size: 3.8vw;
    padding: 1vh 3vw;
  }

  .field-error {
    font-size: 3.5vw;
    margin: 1vh 0 0 0;
  }

  .apply-upload-title {
    font-size: 5vw;
    margin: 4vh 0 2vh 0;
  }

  .apply-drop {
    height: 28vh;
    border-radius: 2vw;
  }

  .apply-drop-icon {
    width: 8vh;
    height: 8vh;
  }

  .apply-drop-text {
    font-size: 4.27vw;
    margin: 2vh 0 1vh 0;
    text-align: center;
  }

  .apply-drop-limit {
    font-size: 3.73vw;
  }

  .apply-file-info {
    font-size: 3.8vw;
    margin: 2vh 0 0 0;
  }

  .success-dialog {
    width: 88%;
    padding: 5vh 6%;
    border-radius: 4vw;
  }

  .success-icon {
    width: 22vh;
  }

  .success-title {
    font-size: 6vw;
    margin: 0 0 2vh 0;
  }

  .success-desc {
    font-size: 4vw;
    margin: 0 0 3vh 0;
  }

  .success-btn {
    width: 70%;
    font-size: 4.5vw;
  }
}
</style>
